type Labeled = { label: string };

function isLabeledObject(obj: unknown): obj is Labeled {
  return typeof obj === 'object' && obj !== null && 'label' in obj;
}

export const transformAttributeForDisplay = (attribute: unknown): string | number => {
  if (typeof attribute === 'string' || typeof attribute === 'number') {
    return attribute;
  }

  if (typeof attribute === 'boolean') {
    return attribute ? 'Yes' : 'No';
  }

  if (Array.isArray(attribute) && attribute.length > 0) {
    const firstItem = attribute[0];
    if (isLabeledObject(firstItem)) {
      return attribute
        .map((item) => (isLabeledObject(item) ? item.label : ''))
        .filter(Boolean)
        .join(', ');
    }
    if (typeof firstItem === 'string' || typeof firstItem === 'number') {
      return attribute.join(', ');
    }
  }

  if (attribute && typeof attribute === 'object' && isLabeledObject(attribute)) {
    return attribute.label;
  }

  return '';
};
